import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"
import { format, parseISO } from 'date-fns';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format a date safely - never throws, returns fallback for invalid/missing input.
export function safeFormat(value, fmt, fallback = '—') {
  try {
    if (!value) return fallback;
    const d = typeof value === 'string' ? parseISO(value) : value;
    if (!(d instanceof Date) || Number.isNaN(d.getTime())) return fallback;
    return format(d, fmt);
  } catch {
    return fallback;
  }
}
